import React, { useState, useRef } from "react";

const ChipInput = ({ values, onChange, placeholder, options, normalizeValue = (val) => val.trim().toUpperCase() }) => {
  const [inputVal, setInputVal] = useState("");
  const inputRef = useRef(null);

  const addValue = (val) => {
    const trimmed = normalizeValue(val);
    if (trimmed && !values.includes(trimmed)) {
      onChange([...values, trimmed]);
    }
    setInputVal("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addValue(inputVal);
    } else if (e.key === "Backspace" && !inputVal && values.length > 0) {
      onChange(values.slice(0, -1));
    }
  };

  const handleSelectChange = (e) => {
    const val = e.target.value;
    if (val && !values.includes(val)) {
      onChange([...values, val]);
    }
    e.target.value = "";
  };

  return (
    <div className="chip-input-area" onClick={() => inputRef.current?.focus()}>
      {values.map((v) => (
        <span key={v} className="chip">
          {v}
          <span className="chip-remove" onClick={(e) => { e.stopPropagation(); onChange(values.filter((x) => x !== v)); }}>×</span>
        </span>
      ))}
      {options ? (
        <select onChange={handleSelectChange} style={{ border: "none", outline: "none", fontSize: 13, flex: 1, minWidth: 80, background: "transparent" }}>
          <option value="">{placeholder}</option>
          {options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <input
          ref={inputRef}
          className="chip-input"
          value={inputVal}
          onChange={(e) => setInputVal(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={() => { if (inputVal) addValue(inputVal); }}
          placeholder={values.length === 0 ? placeholder : ""}
        />
      )}
    </div>
  );
};

export default ChipInput;
